<template>
  <div class="container">
    <head-nav-bar
      title="中央预订"
      :fixed="true"
      rightText="筛选"
      @click-left="$router.go(-1)"
      @click-right="onSearchClick"
    />
    <div class="mt-header-nav">
      <van-search
        placeholder="请输入房号、入住人、订单号、手机号等"
        style="border-bottom:1px solid #f1f1f1;"
        show-action
        shape="round"
        v-model="searchData.KeyWord"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
      <div style="height:calc(100vh - 150px)" class="order-list">
        <DataList :api="getList" :params="params">
          <template v-slot:item="item">
            <div @click="checkDetail(item)">
              <h3 class="company-name">{{ item.CompanyName }}</h3>
              <p class="info">
                <span>订房热线：{{ item.BookingPhone }}</span>
                <span>地址：{{ item.Address }}</span>
              </p>
              <div class="right">
                <van-button class="check-link" type="info" size="small" round
                  >详情</van-button
                >
                <span
                  >剩余：<em>{{ item.RestRoomCount }}</em> 间</span
                >
              </div>
            </div>
          </template>
        </DataList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Search, Button } from "vant";
import { getGSelectData } from "@/api/common.js";
import groupOrderApi from "../../api/group_order.js";
import DataList from "@/components/DataList";
import searchPopup from "@/components/searchPopup";
import moment from "moment";
import { jump } from "@/utils/common.js";
import { ls } from "@/utils/cache.js";
export default {
  name: "groupCenterOrder",
  components: {
    [Search.name]: Search,
    [Button.name]: Button,
    DataList,
  },
  data() {
    return {
      getList: groupOrderApi.GetGroupBookingList,
      params: {},
      bookingLis: [],
      companyList: [],
      searchData: {
        KeyWord: "",
        datarange: [],
      },
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  created() {
    this.params = {
      BeginDate: this.user.AccountDate,
      EndDate: moment(this.user.AccountDate)
        .add("days", 1)
        .format("YYYY-MM-DD"),
    };
    this.searchData.datarange = [this.params.BeginDate, this.params.EndDate];
    this.getData();
  },
  methods: {
    onSearch() {
      this.params = {
        Keyword: this.searchData.KeyWord,
      };
    },
    onSearchClick() {
      searchPopup({
        title: "筛选",
        styles: {
          width: "90%",
        },
        content: [
          {
            label: "住店日期",
            name: "DateRange",
            type: "dateRange",
            props: {
              defaultValue: this.searchData.datarange,
            },
          },
          {
            label: "门店",
            name: "CompanyId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: "",
            },
            data: this.companyList,
          },
        ],
        submit: values => {
          let params = {
            CompanyId: values.CompanyId,
            BeginDate: values.DateRange
              ? values.DateRange[0]
              : this.user.AccountDate,
            EndDate: values.DateRange
              ? values.DateRange[1]
              : moment(this.user.AccountDate)
                  .add("days", 1)
                  .format("YYYY-MM-DD"),
            KeyWord: values.KeyWord,
          };
          this.searchData.datarange = [params.BeginDate, params.EndDate];
          this.params = { ...this.params, ...params };
        },
      });
    },
    getData() {
      getGSelectData({ Types: "company" }).then(res => {
        this.companyList = res.Data.company;
      });
    },
    checkDetail(item) {
      ls.set("current_daterange", this.searchData.datarange);
      jump("groupCentralOrderDetail", { Id: item.Id, Name: item.CompanyName });
    },
  },
};
</script>

<style lang="less" scoped>
.order-list /deep/ .list-item {
  border-bottom: 0;
  margin: 10px;
  box-shadow: 1px 1px 3px #cfcdcd;
  padding: 5px 10px;
  border-radius: 3px;
  position: relative;

  .right {
    position: absolute;
    right: 10px;
    top: 10px;
    text-align: center;
    .check-link {
      height: 0.7rem;
      line-height: 0.6rem;
    }
    & > span {
      display: block;
      color: #999;
      margin-top: 5px;
      font-size: 12px;
      em {
        color: #f50;
        font-size: 14px;
      }
    }
  }
}
.company-name {
  font-weight: normal;
  text-align: left;
  color: #000;
  margin-bottom: 5px;
}
.info {
  span {
    display: block;
    color: #999;
    font-size: 12px;
    line-height: 1.5;
  }
}
</style>
